import { render, staticRenderFns } from "./raw_material.vue?vue&type=template&id=9260133c&scoped=true"
import script from "./raw_material.vue?vue&type=script&lang=js"
export * from "./raw_material.vue?vue&type=script&lang=js"
import style0 from "./raw_material.vue?vue&type=style&index=0&id=9260133c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9260133c",
  null
  
)

export default component.exports